
import { BaseLayoutFactory } from "../base-layout/base-layout-factory";
import { LoginProvider } from "./context/login-context";
import { Login } from "./login";

export function IndexFactory() {
    return (
        <BaseLayoutFactory>
            <LoginProvider>
                <Login />
            </LoginProvider>
        </BaseLayoutFactory>
    );
}